// Friends + proximity-invite wire types (Phase 7 Block F).
//
// No import from messages.ts — sibling files define types inline to
// avoid circular deps (same pattern as skill-messages.ts).

// C→S
export type ClientRequestNearbyPlayers = {
  type: "requestNearbyPlayers";
  ts: number;
  payload: Record<string, never>;
};
export type ClientAddFriend = {
  type: "addFriend";
  ts: number;
  payload: { name: string };
};
export type ClientRemoveFriend = {
  type: "removeFriend";
  ts: number;
  payload: { friendPlayerId: string };
};

// S→C
export type NearbyPlayer = { playerId: string; displayName: string; x: number; y: number };
export type ServerNearbyPlayers = {
  type: "nearbyPlayers";
  ts: number;
  payload: { players: NearbyPlayer[] };
  seq?: number;
  eventId?: string;
};

export type FriendEntry = { playerId: string; displayName: string; online: boolean };
export type ServerFriendsListUpdated = {
  type: "friendsListUpdated";
  ts: number;
  payload: { friends: FriendEntry[] };
  seq?: number;
  eventId?: string;
};

// Builders
export const buildRequestNearbyPlayersMessage = (): ClientRequestNearbyPlayers => ({
  type: "requestNearbyPlayers",
  ts: Date.now(),
  payload: {},
});

export const buildAddFriendMessage = (name: string): ClientAddFriend => ({
  type: "addFriend",
  ts: Date.now(),
  payload: { name },
});

export const buildRemoveFriendMessage = (friendPlayerId: string): ClientRemoveFriend => ({
  type: "removeFriend",
  ts: Date.now(),
  payload: { friendPlayerId },
});

export const buildNearbyPlayersMessage = (players: NearbyPlayer[]): ServerNearbyPlayers => ({
  type: "nearbyPlayers",
  ts: Date.now(),
  payload: { players },
});

export const buildFriendsListUpdatedMessage = (friends: FriendEntry[]): ServerFriendsListUpdated => ({
  type: "friendsListUpdated",
  ts: Date.now(),
  payload: { friends },
});
